import { useSnackbar } from 'notistack';
import { Navigate, Outlet } from 'react-router-dom';

import { Roles } from '@/utils/roles';
import { useAuthContext } from '@/hooks/useAuthContext';
import Splash from '@commons/splash';
import { FeaturesEnum } from '@utils/features';
import RolesGuard from '@/context/auth/RolesGuard';

type AuthGuardProps = {
  feature?: keyof typeof FeaturesEnum;
  roles?: number[];
};

export default function FeaturesGuard({ feature, roles=[] }: AuthGuardProps) {
  const { isInitialized, user, subscriptions } = useAuthContext();
  const { enqueueSnackbar } = useSnackbar();

  if (subscriptions.loading || !isInitialized) {
    return <Splash />;
  }
  if(Roles.OWNER_SOFT === user?.role?.id){

    return <RolesGuard roles={roles} />;
  }
  if(!subscriptions?.data?.isActive){
    enqueueSnackbar('No cuentas con los permisos suficientes', {
      variant: 'warning',
      autoHideDuration: 2000,
    });
    return <Navigate to="/dashboard/app" />;
  }
  if(feature && !subscriptions?.data?.features?.includes?.(feature)){
    enqueueSnackbar('No cuentas con los permisos suficientes', {
      variant: 'warning',
      autoHideDuration: 2000,
    });
    return <Navigate to="/dashboard/app" />;
  }
  if(!roles.length) {
    return <Outlet/>
  }


  return <RolesGuard roles={roles} />;
}
